import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';


@Injectable()
export class EmployeeProvider {

  constructor(public http: HttpClient) {
  }

}



// WEBPACK FOOTER //
// ./src/providers/employee/employee.ts